<template>
  <validation-observer ref="simpleRules">
    <b-card :title="assembleia.titulo">
      <b-form>
        <b-tabs>
          <b-tab active>
            <template #title>
              <feather-icon icon="HomeIcon" />
              <span>Sobre</span>
            </template>

            <b-row>
              <b-col cols="12">
                <b-form-group>
                  <validation-provider
                    #default="{ errors }"
                    name="Título"
                    rules="required"
                  >
                    <b-form-input
                      v-model="assembleia.titulo"
                      :state="errors.length > 0 ? false : null"
                      placeholder="Título"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
              >
                <b-form-group>
                  <flat-pickr
                    v-model="assembleia.dataHoraInicio"
                    :config="configFromdateTimePicker"
                    placeholder="Data de Abertura"
                    @on-change="onFromChange"
                  />
                </b-form-group>
              </b-col>
              <b-col
                cols="12"
                md="6"
              >
                <b-form-group>
                  <flat-pickr
                    v-model="assembleia.dataHoraEncerramento"
                    :config="configTodateTimePicker"
                    placeholder="Data de Encerramento"
                    @on-change="onToChange"
                  />
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>
          <b-tab>
            <template #title>
              <feather-icon icon="EyeIcon" />
              <span>Edital</span>
            </template>

            <quill-editor
              v-model="assembleia.pauta"
              :options="editorEditalOptions"
              class="editor"
            />
          </b-tab>
          <b-tab>
            <template #title>
              <feather-icon icon="ToolIcon" />
              <span>Configurações</span>
            </template>

            <b-row>
              <b-col cols="3">
                <b-form-group>
                  <b-form-radio
                    v-model="assembleia.situacao"
                    color="primary"
                    value="RASCUNHO"
                  >Rascunho</b-form-radio>
                </b-form-group>
              </b-col>

              <b-col cols="3">
                <b-form-group>
                  <b-form-radio
                    v-model="assembleia.situacao"
                    color="success"
                    value="INICIADA"
                  >Iniciada</b-form-radio>
                </b-form-group>
              </b-col>

              <b-col cols="3">
                <b-form-group>
                  <b-form-radio
                    v-model="assembleia.situacao"
                    color="warning"
                    value="ENCERRADA"
                  >Encerrada</b-form-radio>
                </b-form-group>
              </b-col>

              <b-col cols="3">
                <b-form-group>
                  <b-form-radio
                    v-model="assembleia.situacao"
                    color="danger"
                    value="CANCELADA"
                  >Cancelada</b-form-radio>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox
                    v-model="assembleia.votoOculto"
                    switch
                    inline
                  >Voto oculto durante a assembleia.</b-form-checkbox>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox
                    v-model="assembleia.votoInadimplente"
                    switch
                    inline
                  >Permitir voto de inadimplentes.</b-form-checkbox>
                </b-form-group>
              </b-col>

              <b-col cols="12">
                <b-form-group>
                  <b-form-checkbox
                    v-model="assembleia.votoPorFracao"
                    switch
                    inline
                  >Contabilização do votos por fração.</b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>

        <b-col cols="12">
          <b-button
            variant="primary"
            type="submit"
            @click.prevent="validationForm"
          >
            Salvar
          </b-button>
          <b-button
            variant="primary"
            type="submit"
            @click="gravarAssembleia"
          >Gravar</b-button>
        </b-col>
      </b-form>
    </b-card>
  </validation-observer>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BFormInput,
  BFormRadio,
  BFormGroup,
  BForm,
  BFormCheckbox,
} from 'bootstrap-vue'
import { required } from '@validations'
import flatPickr from 'vue-flatpickr-component'
import { Portuguese } from 'flatpickr/dist/l10n/pt'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import { quillEditor } from 'vue-quill-editor'

import AssembleiaAPI from '@/api/assembleia'

export default {
  components: {
    flatPickr,
    quillEditor,
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BFormRadio,
    BForm,
    BFormCheckbox,
  },
  data() {
    return {
      required,
      assembleia: {
        id: 0,
        situacao: 'RASCUNHO',
        titulo: '',
        pauta: '',
        ata: null,
        dataHoraInicio: new Date(),
        dataHoraEncerramento: new Date(),
        votoOculto: false,
        votoInadimplente: false,
        votoPorFracao: false,
      },
      configFromdateTimePicker: {
        locale: Portuguese,
        enableTime: true,
        inline: true,
        altInput: true,
        altFormat: 'd/m/Y H:i',
        dateFormat: 'Z',
        wrap: true,
      },
      configTodateTimePicker: {
        locale: Portuguese,
        enableTime: true,
        inline: true,
        altInput: true,
        altFormat: 'd/m/Y H:i',
        dateFormat: 'Z',
        wrap: true,
      },
      editorEditalOptions: {
        placeholder: 'Escreva aqui o edital de convocação da assembleia.',
        theme: 'snow',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'], // toggled buttons
            ['blockquote'],
            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ script: 'sub' }, { script: 'super' }], // superscript/subscript
            [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
            [{ direction: 'rtl' }], // text direction
            [{ size: ['small', false, 'large', 'huge'] }], // custom dropdown
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ font: [] }],
            [{ align: [] }],
            ['link', 'image', 'video', 'formula'],
            ['clean'], // remove formatting button
          ],
        },
      },
    }
  },
  created() {
    if (this.$route.params.id) {
      this.assembleia.id = this.$route.params.id
      this.getAssembleia()
      this.wizard = false
    }
  },
  methods: {
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          // eslint-disable-next-line
          alert('form submitted!')
        }
      })
    },
    // eslint-disable-next-line
    onFromChange(selectedDates, dateStr) {
      this.$set(this.configTodateTimePicker, 'minDate', dateStr)
    },
    // eslint-disable-next-line
    onToChange(selectedDates, dateStr) {
      this.$set(this.configFromdateTimePicker, 'maxDate', dateStr)
    },
    gravarAssembleia() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll('configuracoes').then(result => {
          if (result) {
            if (!this.assembleia.id) {
              this.createAssembleia()
            } else {
              this.patchAssembleia()
            }
            resolve(true)
          } else {
            reject(new Error('Corriga os campos'))
          }
        })
      })
    },
    createAssembleia() {
      this.$loading.show()
      AssembleiaAPI.createAssembleia(this.assembleia)
        .then(response => {
          this.$loading.hide()
          this.assembleia.id = response.data.id
          this.$emit('gravado', this.assembleia)
          this.$toast.success('Assembleia criada com sucesso')
        })
        .catch(error => {
          this.$loading.hide()
          this.$toast.error(error.response.data.error)
        })
    },
    getAssembleia() {
      this.$loading.show()
      AssembleiaAPI.getAssembleia(this.assembleia.id)
        .then(response => {
          this.$loading.hide()
          this.assembleia = response.data
        })
        .catch(error => {
          this.$loading.hide()
          this.$toast.error(error.response.data.error)
        })
    },
    patchAssembleia() {
      this.$loading.show()
      AssembleiaAPI.patchAssembleia(this.assembleia.id, this.assembleia)
        .then(() => {
          this.$loading.hide()
          this.$emit('gravado', this.assembleia)
          this.$toast.success('Assembleia atualizada com sucesso')
        })
        .catch(error => {
          this.$loading.hide()
          this.$toast.error(error.response.data.error)
        })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
